import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {LoadingService} from '@nh/angular-tses';
import {DepartureService} from '../../services/departure.service';

@Component({
  selector: 'das-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  public creatingNewDeparture: boolean;

  constructor(private departureService: DepartureService, private router: Router) {}

  ngOnInit() {}

  public create(): void {
    this.setLoadingState(true);
    this.departureService
      .create()
      .then((departureId: number) => {
        return this.router.navigateByUrl(`/departures/${departureId}/revisions/0`);
      })
      .catch(err => this.setLoadingState(false))
      .then(err => this.setLoadingState(false));
  }

  private setLoadingState(loading: boolean): void {
    this.creatingNewDeparture = loading;
    LoadingService.setLoadingState(loading);
  }
}
